exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".region{color:red}.pre_attendance{width:1px;padding:0!important}.pre_attendance .pre_attendance-icon{font-size:24px;margin:auto;position:relative;display:block;width:fit-content}.label-pre-attendance{top:-49px;font-size:13px}#addSpecialSchedules{text-transform:none}#addSpecialSchedules .schedules-header-icon{color:#b90a00}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/region/region.scss
// module id = 612
// module chunks = 0